/* convert from 24 hour format to 12 hour format with a.m./p.m. */
export const formatTime = time => {
  const hours = time.toString().split(':')[0],
    minutes = time.toString().split(':')[1],
    formattedHours = ((parseInt(hours, 10) + 11) % 12) + 1,
    am = hours == 24 || hours < 12

  return `${formattedHours}:${minutes} ${am ? 'a.m.' : 'p.m.'}`
}
